module.exports = __webpack_public_path__ + "img/section-4-5.e48d170.webp";